import {CallUsageActionTypes} from '../actions/callUsage'

export interface CallUsageState {
  callUsage: Array<any>
  callUsageTotalCount: number
  callUsagePage: number
  callUsageOverview: Array<any>
  callUsageOverviewTotalCount: number
  callUsageOverviewPage: number
  refundResult: string
}

const initialState: CallUsageState = {
  callUsage: [],
  callUsageTotalCount: 0,
  callUsagePage: 1,
  callUsageOverview: [],
  callUsageOverviewTotalCount: 0,
  callUsageOverviewPage: 1,
  refundResult: '',
}

const callUsageReducer = (
  state: CallUsageState = initialState,
  action: CallUsageActionTypes
): CallUsageState => {
  switch (action.type) {
    case 'GET_CALL_USAGE':
      return {
        ...state,
        callUsage: action.payload.callUsage,
        callUsageTotalCount: action.payload.callUsageTotalCount,
        callUsagePage: action.payload.callUsagePage,
      }
    case 'GET_CALL_USAGE_ERROR':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    case 'GET_CALL_USAGE_OVERVIEW':
      return {
        ...state,
        callUsageOverview: action.payload.callUsageOverview,
        callUsageOverviewTotalCount: action.payload.callUsageOverviewTotalCount,
        callUsageOverviewPage: action.payload.callUsageOverviewPage,
      }
    case 'GET_CALL_USAGE_OVERVIEW_ERROR':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    case 'REFUND_CALL_USAGE':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    case 'REFUND_CALL_USAGE_ERROR':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    case 'REFUND_CALL_USAGE_BATCH':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    case 'REFUND_CALL_USAGE_BATCH_ERROR':
      return {
        ...state,
        refundResult: action.payload.result,
      }
    default:
      return state
  }
}

export default callUsageReducer
